import { useLocation } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { fetchSummaryCorporateEvents } from '@apis/performance';
import type { CorporateEventApiItem } from '@app-types/summaryApi';
import { getAccessToken } from '@utils/authStorage';
import { getIframeQueryParamsFromSearch } from '@utils/queryParams';

/**
 * React Query hook for the schedule column (GET /api/summary/corporate-event).
 * Reads ticker/mkt from the router location so URL changes refetch.
 */
export const useSummaryCorporateEvents = () => {
  const location = useLocation();
  const { ticker, mkt } = getIframeQueryParamsFromSearch(location.search);
  const hasToken = Boolean(getAccessToken());

  return useQuery<CorporateEventApiItem[]>({
    queryKey: ['summary', 'corporate-event', ticker, mkt],
    queryFn: () => fetchSummaryCorporateEvents({ ticker: ticker as string, mkt: mkt as string }),
    enabled: Boolean(ticker && mkt && hasToken),
    staleTime: 60_000,
    retry: 1,
  });
};
